"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userProfileInfoUpdate = exports.userProfileInfoSuccess = exports.userProfileInfoReset = exports.userProfileInfoFetch = exports.userProfileInfoError = void 0;
var _userProfileInfo = require("./userProfileInfo.constant");
// common success
var userProfileInfoSuccess = function userProfileInfoSuccess(actionType, data) {
  return {
    type: _userProfileInfo.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.userProfileInfoSuccess = userProfileInfoSuccess;
var userProfileInfoError = function userProfileInfoError(actionType, error) {
  return {
    type: _userProfileInfo.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch info
 * @param payload
 * @returns api response
 * @description this function used to fetch user profile info.
 */
exports.userProfileInfoError = userProfileInfoError;
var userProfileInfoFetch = function userProfileInfoFetch(payload) {
  return {
    type: _userProfileInfo.actionTypes.FETCH,
    payload: payload
  };
};

/**
 * update info
 * @param payload
 * @returns api response
 * @description this function used to update user profile info.
 */
exports.userProfileInfoFetch = userProfileInfoFetch;
var userProfileInfoUpdate = function userProfileInfoUpdate(payload) {
  return {
    type: _userProfileInfo.actionTypes.UPDATE,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.userProfileInfoUpdate = userProfileInfoUpdate;
var userProfileInfoReset = function userProfileInfoReset() {
  return {
    type: _userProfileInfo.actionTypes.RESET
  };
};
exports.userProfileInfoReset = userProfileInfoReset;